import {serializr} from '@mecatran/serializr-extensions';

    var {   createModelSchema, 
        createSimpleSchema, 
        primitive, 
        alias,
        reference, 
        date, raw, list, object, 
        identifier, map, mapAsArray , 
        custom, 
        getDefaultModelSchema, 
		setDefaultModelSchema,
        serialize, 
        deserialize } = serializr;

// export {serializr};

import * as model from "./model.mjs";
export var banServicesConfigModel = model;


function factory(clazz ){
    return function(){
        return new clazz();
    }
}

/* https://geo.api.gouv.fr/adresse */ 
var schemaSearchConfig = {
    factory : factory(model.SearchConfig),
    props : {
        q : true,
        limit : true,
        autocomplete : true,
        lat : true,   // center. Does not work well ?
        lon : true,   // center. Does not work well ?
        type : true,  // street. housenumber. municipality. locality.
        postcode : true,
        citycode : true,
        bounds : object(model.Bounds),
		mainCity : alias('maincity', true)
    }
}

var schemaPoint = {  // TMP relocate to GIS-lib 
    factory : factory(model.Point),
    props : {
        lat : true,
        lon : true
    }
}


var schemaBounds = {   // TMP. Relocate to GIS-lib
    factory : factory(model.Bounds),
    props : {
        ne : object(model.Point), 
        sw : object(model.Point)
    }
}

var schemaBanServicesConfig = {
    factory : factory(model.BanServicesConfig),
    props : {
        search : object(model.SearchConfig),
    }
}

setDefaultModelSchema(model.SearchConfig, schemaSearchConfig);
setDefaultModelSchema(model.Point, schemaPoint);
setDefaultModelSchema(model.Bounds, schemaBounds);
setDefaultModelSchema(model.BanServicesConfig, schemaBanServicesConfig);




